import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Pagination, Select, Input, Global } from '@mantine/core'
import StylePagination from './styled/pagination'
import RenderIf from '../render-if'

const PaginationComps = (props) => {
  const {
    style,
    className,
    defaultPage,
    pageSize,
    total,
    pageSizeOptions,
    showPageSize,
    onPageNumChange,
    onPageSizeChange,
    onPressEnter,
    showJumpPage = true,
  } = props
  const [inputVal, setInputVal] = useState('')
  const [currentPageSize, setCurrentPageSize] = useState(pageSize)
  const pageCount = Math.ceil(total / currentPageSize) || 1
  const [currentPage, setCurrentPage] = useState(defaultPage)
  const pageSizeOptionsArr = (pageSizeOptions || []).map((v) => {
    return `每页${v}条`
  })
  useEffect(() => {
    setCurrentPage(defaultPage)
  }, [defaultPage])

  useEffect(() => {
    setCurrentPageSize(pageSize)
  }, [pageSize])

  const onChangePage = (page) => {
    setInputVal('')
    setCurrentPage(page)
    if (onPageNumChange) {
      onPageNumChange(page)
    }
  }

  const onPressEnterPage = () => {
    let curPage = 1
    if (inputVal > pageCount) {
      curPage = pageCount
    } else if (inputVal < 1) {
      curPage = 1
    } else {
      curPage = inputVal
    }
    setCurrentPage(curPage)
    if (onPressEnter) {
      onPressEnter(curPage)
    }
    if (onPageNumChange) {
      onPageNumChange(curPage)
    }
  }
  const onChangeInput = (e) => {
    let pageTemp = e.target.value
    if (pageTemp) {
      if (!/^[0-9]*$/.test(pageTemp)) {
        pageTemp = 1
      }
      setInputVal(Number(pageTemp))
    } else {
      setInputVal('')
    }
  }
  return (
    <StylePagination
      style={style}
      className={clsx('dark:bg-darkTheme-1100 dark:text-gray-400', className)}
    >
      <Global
        styles={() => ({
          '.dark': {
            '.mantine-Group-root': {
              button: {
                color: '#fff',
                border: '1px solid var(--ow-color-darkTheme-800)',
              },
            },
            '.mantine-Input-input': {
              background: 'var(--ow-color-darkTheme-1100)',
              border: '1px solid var(--ow-color-darkTheme-800)',
              color: '#fff',
            },
            '.mantine-Select-input': {
              backgroundColor: 'unset',
              border: '1px solid var(--ow-color-darkTheme-800)',
              color: '#fff',
            },
            '.mantine-Select-dropdown': {
              background: 'var(--ow-color-darkTheme-1100)',
              border: '1px solid var(--ow-color-darkTheme-800)',
            },
            '.mantine-Select-item': {
              color: '#fff',
              '&[data-selected]': {
                '&, &:hover': {
                  background: 'var(--ow-color-darkTheme-900)',
                },
              },
              '&[data-hovered]': {
                background: 'var(--ow-color-darkTheme-900)',
              },
            },
          },
        })}
      />
      <div className="total hidden md:block dark:text-gray-400">
        <span>共 {total} 项数据 </span>
      </div>
      <Select
        className="hidden md:block"
        data={pageSizeOptionsArr}
        value={`每页${currentPageSize}条`}
        style={{ width: '130px', marginRight: '20px' }}
        styles={() => ({
          item: {
            '&[data-selected]': {
              '&, &:hover': {
                backgroundColor: `var(--ow-color-primary-700)`,
              },
            },
          },
        })}
        onChange={(e) => {
          const size = e.replace(/[^\d]/g, '')
          setCurrentPageSize(size)
          setCurrentPage(1)
          setInputVal('')
          if (onPageSizeChange) {
            onPageSizeChange(size)
          }
        }}
      />
      <Pagination
        total={pageCount}
        // classNames={{
        //   active: 'bg-primary-700',
        // }}
        styles={() => ({
          item: {
            '&[data-active]': {
              backgroundColor: `var(--ow-color-primary-700)`,
            },
          },
        })}
        page={currentPage}
        onChange={onChangePage}
        withControls={false}
      />

      <RenderIf isTrue={showJumpPage}>
        <div className="hidden md:block">
          <div className="goto-page">
            <span className="dark:text-gray-400">跳至</span>
            <Input
              value={inputVal}
              onChange={onChangeInput}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  event.preventDefault()
                  onPressEnterPage()
                }
              }}
              style={{ width: '70px', margin: '0 10px' }}
            />
            <span className="dark:text-gray-400">页</span>
          </div>
        </div>
      </RenderIf>
      <RenderIf isTrue={showPageSize}>
        <div className="total-count hidden md:block  dark:text-gray-400">
          共{Math.ceil(pageCount)}页
        </div>
      </RenderIf>
    </StylePagination>
  )
}
PaginationComps.propTypes = {
  defaultPage: PropTypes.number,
  pageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  total: PropTypes.number,
  showJumpPage: PropTypes.bool,
  showPageSize: PropTypes.bool,
  onPageNumChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  onPressEnter: PropTypes.func,
}
PaginationComps.defaultProps = {
  defaultPage: 1,
  pageSize: undefined,
  pageSizeOptions: undefined,
  total: undefined,
  showJumpPage: true,
  showPageSize: false,
  onPageNumChange: () => {},
  onPageSizeChange: () => {},
  onPressEnter: () => {},
}
export default PaginationComps
